import Axios from "axios";
const ServiceURL = process.env.VUE_APP_SERVICEURL;

export default {
  name: "status",
  state: {
    cost_center: [],
    peruntukan: [],
    subPeruntukan: [],
    anggaran: [],
    non_taktis: [],
    jenis_anggaran: [],
    jenis_anggaranSppd:[]
  },
  getters: {
    getCostCenter: (state) => {
      return state.cost_center;
    },
    getPeruntukan: (state) => {
      return state.peruntukan;
    },
    getSubPeruntukan: (state) => {
      return state.subPeruntukan;
    },
    getAnggaran: (state) => {
      return state.anggaran;
    },
    getNonTaktis: (state) => {
      return state.non_taktis;
    },
    getJenisAnggaran: (state) => {
      return state.jenis_anggaran;
    },
  },
  mutations: {
    SET_COST_CENTER: (state, payload) => {
      state.cost_center = payload;
    },
    SET_PERUNTUKAN: (state, payload) => {
      state.peruntukan = payload;
    },
    SET_SUB_PERUNTUKAN: (state, payload) => {
      state.subPeruntukan = payload;
    },
    SET_ANGGARAN: (state, payload) => {
      state.anggaran = payload;
    },
    SET_NON_TAKTIS: (state, payload) => {
      state.non_taktis = payload;
    },
    SET_JENIS_ANGGARAN: (state, payload) => {
      state.jenis_anggaran = payload;
    },
  },
  actions: {
    async FETCH_COST_CENTER(store) {
      return await Axios({
        method: "get",
        url: ServiceURL + "main/cost_center",
        params: {
          tlc: store.rootState.user.auth.username,
        },
        auth: {
          username: store.rootState.user.auth.username,
          password: store.rootState.user.auth.password,
        },
        headers: {
          "X-API-KEY": store.rootState.user.auth.apikey,
        },
      })
        .then((response) => {
          store.commit("SET_COST_CENTER", response.data.cost_center);
          store.commit("SET_PERUNTUKAN", response.data.peruntukan);
          store.commit("SET_SUB_PERUNTUKAN", response.data.sub_peruntukan);
          store.commit("SET_ANGGARAN", response.data.kode_anggaran);
          store.commit("SET_JENIS_ANGGARAN", response.data.jenis_anggaran);
        })
        .catch((err) => {
          return err;
        });
    },
    async FETCH_COST_CENTER_NON_TAKTIS(store) {
      return await Axios({
        method: "get",
        url: ServiceURL + "main/cost_center_non_taktis",
        params: {
          tlc: store.rootState.user.auth.username,
        },
        auth: {
          username: store.rootState.user.auth.username,
          password: store.rootState.user.auth.password,
        },
        headers: {
          "X-API-KEY": store.rootState.user.auth.apikey,
        },
      })
        .then((response) => {
          store.commit("SET_NON_TAKTIS", response.data);
          store.commit("SET_JENIS_ANGGARAN", response.data.jenis_anggaran);
        })
        .catch((err) => {
          return err;
        });
    },
    async FETCH_COST_CENTER_SPPD(store) {
      return await Axios({
        method: "get",
        url: ServiceURL + "main/cost_center_non_taktis_sppd",
        params: {
          tlc: store.rootState.user.auth.username,
        },
        auth: {
          username: store.rootState.user.auth.username,
          password: store.rootState.user.auth.password,
        },
        headers: {
          "X-API-KEY": store.rootState.user.auth.apikey,
        },
      })
        .then((response) => {
          store.commit("SET_NON_TAKTIS", response.data);
          store.commit("SET_JENIS_ANGGARAN", response.data.jenis_anggaran);
        })
        .catch((err) => {
          return err;
        });
    },
    // Cost Center khusus untuk KD = Klaim Direktur
    async FETCH_COST_CENTER_KD(store) {
      return await Axios({
        method: "get",
        url: ServiceURL + "main/cost_center",
        params: {
          tlc: store.rootState.user.auth.username+'-KD',
        },
        auth: {
          username: store.rootState.user.auth.username,
          password: store.rootState.user.auth.password,
        },
        headers: {
          "X-API-KEY": store.rootState.user.auth.apikey,
        },
      })
          .then((response) => {
            store.commit("SET_COST_CENTER", response.data.cost_center);
            store.commit("SET_PERUNTUKAN", response.data.peruntukan);
            store.commit("SET_SUB_PERUNTUKAN", response.data.sub_peruntukan);
            store.commit("SET_ANGGARAN", response.data.kode_anggaran);
            store.commit("SET_JENIS_ANGGARAN", response.data.jenis_anggaran);
          })
          .catch((err) => {
            return err;
          });
    },
  },
};
